import React, { useState } from "react";
import PickupForm from "../../components/dashboard/rates/PickupForm";

import styles from "./Rates.module.css";
import DeliveryForm from "../../components/dashboard/rates/DeliveryForm";
import RatesTable from "../../components/dashboard/rates/RatesTable";
import Canpar from "../../components/dashboard/rates/Canpar";
import GLS from "../../components/dashboard/rates/GLS";
import PurolatorGround from "../../components/dashboard/rates/PurolatorGround";
import PurolatorExpress from "../../components/dashboard/rates/PurolatorExpress";
import PurolatorExpress12 from "../../components/dashboard/rates/PurolatorExpress12";
import AdditionalForm from "../../components/dashboard/rates/AdditionalInfo";
import { api } from "../../api/api";
import { toast } from "react-toastify";

function Rates() {
  const [delivery, setDelivery] = useState({
    name: "",
    address: "",
    city: "",
    province: "",
    country: "CA-CANADA",
    zip: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [canpar, setCanpar] = useState();
  const [pulato, setPulato] = useState();
  const [gls, setGls] = useState();
  const [canparError, setCanparError] = useState();
  const [glsError, setGlsError] = useState();
  const [pulatoError, setPulatoError] = useState();
  const [pickup, setPickup] = useState({
    name: "Mobb Medical",
    address: "116A Viceroy Rd,#5",
    city: "Concord",
    province: "ON",
    country: "CA-CANADA",
    zip: "L4K2M1",
  });
  const [additional, setAdditional] = useState({ service: "ground" });
  const [isResidential, setIsResidential] = useState(false);

  const changeHandlerPickup = (data) => {
    setPickup(data);
  };
  const changeHandlerDelivery = (data) => {
    setDelivery(data);
  };
  const changeAdditional = (data) => {
    setAdditional({ service: data });
  };
  const changeResidentialHandler = (value) => {
    setIsResidential(value);
  };
  const submitDataHandler = async (data, packages) => {
    if (delivery.name.trim().length === 0) {
      toast.error("Name Is Required");
    } else if (delivery.address.trim().length === 0) {
      toast.error("Address Is Required");
    } else if (delivery.city.trim().length === 0) {
      toast.error("City Is Required");
    } else if (delivery.province.trim().length === 0) {
      toast.error("Province Is Required");
    } else if (delivery.zip.trim().length === 0) {
      toast.error("Postal Code Is Required");
    } else if (packages.length === 0) {
      toast.error("Please Add Some Boxes");
    } else {
      const dataSet = {
        sender: pickup,
        receiver: delivery,
        serviceType: additional.service,
        totalBox: data,
        boxes: packages,
        isResidential: isResidential,
      };
      try {
        setIsLoading(true);
        const req = await api.post("rates/getRates", dataSet);
        const canpurData = req.data.capur;
        if (canpurData.error) {
          setCanparError(canpurData.error);
        } else {
          setCanpar(canpurData);
          setCanparError(null);
        }
        const glsData = req.data.gls;
        if (glsData.error) {
          setGlsError(glsData.error);
        } else {
          setGls(glsData);
          setGlsError(null);
        }
        const pulatoData = req.data.pulator;
        if (pulatoData.error) {
          setPulatoError(pulatoData.error);
        } else {
          setPulato(pulatoData);
          setPulatoError(null);
        }
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(
          err.response.data.error || "Something Went Wrong. Check Values"
        );
      }
    }
  };

  // Clear All Data
  const clearAllHandler = () => {
    setPickup({
      name: "Mobb Medical",
      address: "116A Viceroy Rd,#5",
      city: "Concord",
      province: "ON",
      country: "CA-CANADA",
      zip: "L4K2M1",
    });
    setDelivery({
      name: "",
      address: "",
      city: "",
      province: "",
      country: "CA-CANADA",
      zip: "",
    });
    setAdditional({ service: "ground" });
    setCanpar(null);
    setPulato(null);
    setGls(null);
    setCanparError(null);
    setGlsError(null);
    setPulatoError(null);
  };

  return (
    <div className={styles.container}>
      <div className={styles.information}>
        <PickupForm onChange={changeHandlerPickup} />
        <DeliveryForm onChange={changeHandlerDelivery} />
        <div className={styles.detailsCtn}>
          <AdditionalForm
            onChange={changeAdditional}
            onResidentialChange={changeResidentialHandler}
          />
          <div className={styles.ratesTable}>
            <RatesTable
              isLoading={isLoading}
              onSubmit={submitDataHandler}
              onClearAll={clearAllHandler}
            />
          </div>
        </div>
      </div>
      {/* <div style={{ marginTop: "10px" }}>
        <AdditionalForm onChange={changeAdditional} />
      </div> */}
      {!isLoading && (
        <>
          <div className={styles.ratesCanparAGls}>
            {gls && !glsError && <GLS data={gls} />}
            {glsError && (
              <div className={styles.errorBox}>
                <h1>GLS Rate</h1>
                <h2>{glsError}</h2>
              </div>
            )}
            {canpar && !canparError && <Canpar data={canpar} />}
            {canparError && (
              <div className={styles.errorBox}>
                <h1>Canpar Rate</h1>
                <h2>{canparError}</h2>
              </div>
            )}
          </div>
          <div className={styles.purolator}>
            {pulato && !pulatoError && (
              <>
                <PurolatorGround data={pulato} />
                <PurolatorExpress data={pulato} />
                <PurolatorExpress12 data={pulato} />
              </>
            )}
            {pulatoError && (
              <div className={styles.errorBox}>
                <h1>Purolator Rate</h1>
                <h2>{pulatoError}</h2>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Rates;
